var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visiblePopup,
            top: "100px",
            width: "500px",
            title: "订单状态修改",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visiblePopup = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pramrs", attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单标号", prop: "orderNo" } },
                [_c("span", [_vm._v(_vm._s(_vm.pramrs.orderNo))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "订单商品", prop: "skuName" } },
                [_c("span", [_vm._v(_vm._s(_vm.pramrs.skuName))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "当前状态", prop: "statusName" } },
                [_c("span", [_vm._v(_vm._s(_vm.pramrs.statusName))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "修正状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.pramrs.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pramrs, "status", $$v)
                        },
                        expression: "pramrs.status",
                      },
                    },
                    _vm._l(_vm.statusList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleApiSubmit },
                },
                [_vm._v("确认修改")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "link" },
                  on: {
                    click: function ($event) {
                      _vm.visiblePopup = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }